import { render, staticRenderFns } from "./SettingsNav.vue?vue&type=template&id=7d5df746&scoped=true&"
import script from "./SettingsNav.vue?vue&type=script&lang=js&"
export * from "./SettingsNav.vue?vue&type=script&lang=js&"
import style0 from "./SettingsNav.vue?vue&type=style&index=0&id=7d5df746&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5df746",
  null
  
)

export default component.exports